<div class="p-grid">
	<div class="p-col-12">
		<div class="d-flex">
			<div class="h4 ms-1 mt-2 mb-1">Prices</div>
		</div>
		<p-divider></p-divider>
		<div class="d-flex flex-column">
			<div class="p-grid">
				<div class="p-col p-text-bold">
					<span *ngIf="menuItem.priceLevel">
						{{ priceLevel?.priceDisplayName1 || priceLevel?.priceName1 }}
					</span>
					<span *ngIf="!menuItem.priceLevel"> Price 1 </span>
				</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.price || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">
					<span *ngIf="menuItem.priceLevel">
						{{ priceLevel?.priceDisplayName2 || priceLevel?.priceName2 }}
					</span>
					<span *ngIf="!menuItem.priceLevel"> Price 2 </span>
				</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.price2 || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">
					<span *ngIf="menuItem.priceLevel">
						{{ priceLevel?.priceDisplayName3 || priceLevel?.priceName3 }}
					</span>
					<span *ngIf="!menuItem.priceLevel"> Price 3 </span>
				</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.price3 || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">
					<span *ngIf="menuItem.priceLevel">
						{{ priceLevel?.priceDisplayName4 || priceLevel?.priceName4 }}
					</span>
					<span *ngIf="!menuItem.priceLevel"> Price 4 </span>
				</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.price4 || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">
					<span *ngIf="menuItem.priceLevel">
						{{ priceLevel?.priceDisplayName5 || priceLevel?.priceName1 }}
					</span>
					<span *ngIf="!menuItem.priceLevel"> Price 5 </span>
				</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.price5 || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">
					<span *ngIf="menuItem.priceLevel">
						{{ priceLevel?.priceDisplayName6 || priceLevel?.priceName6 }}
					</span>
					<span *ngIf="!menuItem.priceLevel"> Price 6 </span>
				</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.price6 || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">Price 7 (Sub)</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.priceSub || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">Price 8 (Extra)</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.priceExtra || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">Price 9 (No)</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.priceNo || 0.0 | currency }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col p-text-bold">Price 10 (Mod)</div>
				<div class="p-col d-flex justify-content-end">
					{{ menuItem.priceMod || 0.0 | currency }}
				</div>
			</div>
		</div>
	</div>
</div>
